import { IonModal } from '@ionic/react'
import React from 'react'
import './index.scss'

interface IModalProps {
  title: string;
  des: string;
  reject?: () => void;
  resolve?: () => void;
}

const NoticeModal: React.FC<IModalProps> = (props: IModalProps) => {
  const { title, des, reject, resolve } = props
  return (
    <IonModal
      cssClass='notice-modal'
      isOpen
      onDidDismiss={reject}
    >
      <div className='modal-content'>
        <div className='title'>{title}</div>
        <div className='des'>{des}</div>
        <div className='modal-btn' onClick={resolve}>{i18n.t('mkt.pointCard.confirm')}</div>
      </div>
    </IonModal>
  )
}

export default NoticeModal
